
























































































































// 企业端pc模板
import JSEncrypt from "jsencrypt";
export default {
  name: "business-alliance",
  props: ["config"],
  data() {
    return {
      openEye: false,
      clock: false,
      checked: false,
      aggreementList: [
        {
          title: "用户注册协议",
          url: "",
        },
        {
          title: "用户隐私协议",
          url: "",
        },
      ],
      tabList: [],
      idx: 0,
      formTest: {
        phone: false,
        checkNum: false,
        password: false,
      },
      formData: {
        phone: "",
        checkNum: "",
        password: "",
      },
    };
  },
  computed: {
    next: function() {
      const flag =
        (this as any).checked &&
        Object.keys((this as any).formData).every(
          (key) => (this as any).formData[key]
        ) &&
        Object.keys((this as any).formTest).every(
          (key) => !(this as any).formTest[key]
        );
      return flag;
    },
  },
  watch: {
    // formData: {
    //   handler(newCul: any) {
    //     console.log(newCul, "newCul");
    //     Object.keys(newCul).every((key) => {
    //       (this as any).test(key);
    //     });
    //   },
    //   deep: true,
    // },
    config: {
      handler(newCul: any) {
        const instance = this as any;
        instance.checked = newCul.protocolStatus;
      },
      immediate: true,
    },
  },
  methods: {
    limit(key: string) {
      if (key === "phone" && (this as any).formData[key].length > 11) {
        (this as any).formData[key] = (this as any).formData[key].slice(0, 11);
      }
    },
    test(key: string) {
      const instance = this as any;
      if (key === "password") {
        const passwordReg = /^[0-9A-Za-z]{6,16}$/;
        if (
          !instance.formData[key] ||
          !passwordReg.test(instance.formData[key])
        ) {
          instance.formTest["password"] = true;
        } else {
          instance.formTest["password"] = false;
        }
      }
      if (key === "phone") {
        const phoneReg = /^[1][0-9]{10}$/;
        if (!instance.formData[key] || !phoneReg.test(instance.formData[key])) {
          instance.formTest["phone"] = true;
        } else {
          instance.formTest["phone"] = false;
        }
      }
    },
    clickFun(index: number) {
      (this as any).idx = index;
      console.log(index, "index");
    },
    goLogin() {
      (this as any).$emit("go-login");
    },
    sendSms() {
      const phoneReg = /^[1][0-9]{10}$/;
      if (
        !(this as any).formData.phone ||
        !phoneReg.test((this as any).formData.phone)
      ) {
        return;
      }
      (this as any).clock = true;
      (this as any).time = 60;
      const inter = setInterval(() => {
        (this as any).time--;
        if ((this as any).time <= 0) {
          clearInterval(inter);
          (this as any).clock = false;
        }
      }, 1000);
      const config = (this as any).config;
      const params = {
        businessType: 2,
        phone: (this as any).formData.phone,
        smsType: config.smsType,
        userType: config.userType,
      };
      (this as any).$emit("send-sms", params);
    },
    encryptDeal(msg: string) {
      const publicKey =
        "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKbpotLkdWJlxvWuydKwQkryMb3m2mZrj8tizRUbwBW9Bnyu0syIXz+IkxP6Z76b4cEO2NyEq5yPcJdaBKynSVcCAwEAAQ==";

      const encrypt = new JSEncrypt();
      encrypt.setPublicKey(publicKey);
      return encrypt.encrypt(msg);
    },
    register() {
      if (!(this as any).next) return;
      const instance = this as any;
      const config = (this as any).config;
      const params = {
        account: (this as any).formData.phone,
        checkNum: (this as any).formData.checkNum,
        userType: config.userType,
        password: instance.encryptDeal((this as any).formData.password),
        businessType: 2,
        source: "pc",
      };
      (this as any).$emit("register-handle", params);
    },
    goUrl(url: string) {
      window.location.href = url;
    },
  },
};
